import { render, staticRenderFns } from "./underwriting.vue?vue&type=template&id=47f416e4&scoped=true&"
import script from "./underwriting.vue?vue&type=script&lang=js&"
export * from "./underwriting.vue?vue&type=script&lang=js&"
import style0 from "./underwriting.vue?vue&type=style&index=0&id=47f416e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f416e4",
  null
  
)

export default component.exports